const getCursorPoint = (e, el) => {
    let point = e.changedTouches ? e.changedTouches[0] : e;
    let x = point.pageX;
    let y = point.pageY;
    if (el) {
        let elRect = el.getBoundingClientRect();
        x -= elRect.left;
        y -= elRect.top;
    }
    return { x: x, y: y };
}

const getRelativePoint = (target, ref) => {
    let rect = target.getBoundingClientRect();
    ref = ref ? ref : target.parentNode;
    let refRect = ref.getBoundingClientRect();
    return { x: rect.left - refRect.left, y: rect.top - refRect.top };
}

const getCenterPoint = (target) => {
    let bouding = target.getBoundingClientRect();
    return { x: (bouding.x + bouding.width * .5), y: (bouding.y + bouding.height * .5) }
}

const isMobileDevice = () => {
    return (typeof window.orientation !== "undefined");
}

const addEventListeners = (target, events, call) => {
    events.split(" ").forEach(event => {
        target.addEventListener(event, call);
    });
}

const removeEventListeners = (target, events, call) => {
    events.split(" ").forEach(event => {
        target.removeEventListener(event, call);
    });
}

const validate = (data) => {
    let valid = true
    data.forEach((obj) => {
        if (!obj.value) valid = false;
    });
    return { valid: valid }
}

export {
    getCursorPoint,
    getRelativePoint,
    getCenterPoint,
    isMobileDevice,
    addEventListeners,
    removeEventListeners,
    validate
}